<template>
	<el-row class="chekup-detail" v-bind:class="backgroundColor">
                
		<!-- Boolean -->
		<div v-if="element.type === 'boolean'" >
			<el-col :md="22" :sm="22" :xs="22">
				<div class="chekup-detail-content">{{element.libelle}}</div> 
			</el-col>
			<el-col :md="2" :sm="2" :xs="2" class="checkboxPosition">
				<div class="cross"><i v-bind:class="nocross" class="el-icon-check iborder"></i></div>
			</el-col>
		</div>

		<!-- Texte -->
		<div v-if="element.type === 'text'" >
			<el-col :md="24" :sm="24" :xs="24">
				<div class="chekup-detail-content" v-html="formatText"></div>
			</el-col>
		</div>

		<!-- image -->
		<div v-if="element.type === 'image'" >
			<el-col :md="24" :sm="24" :xs="24">
				<div class="chekup-detail-content" v-html="formatImage"></div>
			</el-col>
		</div>

		<!-- Temps -->
		<div v-if="element.type === 'temps'" >
			<el-col :md="24" :sm="24" :xs="24">
				<div class="chekup-detail-content" v-html="formatTime"></div>
			</el-col>
		</div>  

		<!-- Artemis Etare ref -->
		<div v-if="element.type === 'artemisEtareRef'" >
			<el-col :md="24" :sm="24" :xs="24">	
				<div class="chekup-detail-content" v-html="name"></div>
			</el-col>
		</div> 

		<!-- Groupe (valeur + coche)-->
		<div v-if="element.type === 'groupe'" >
			<el-col :md="22" :sm="22" :xs="22">
				<div class="chekup-detail-content" v-html="formatGroup"></div>
			</el-col>
			<el-col :md="2" :sm="2" :xs="2" class="checkboxPosition">
				<div class="cross"><i v-bind:class="nocrossGroup" class="el-icon-check iborder"></i></div>
			</el-col>
		</div>

		<!-- Groupe Temps (temps + coche)-->
		<div v-if="element.type === 'groupeTmp'" >
			<el-col :md="22" :sm="22" :xs="22">
				<div class="chekup-detail-content" v-html="formatGroupTemps"></div>
			</el-col>
			<el-col :md="2" :sm="2" :xs="2" class="checkboxPosition">
				<div class="cross"><i v-bind:class="nocrossGroup" class="el-icon-check iborder"></i></div>
			</el-col>
		</div>

		<!-- GroupeAge (valeur + valeur)-->
		<div v-if="element.type === 'groupeAge'" >
			<el-col :md="24" :sm="24" :xs="24">
				<div class="chekup-detail-content" v-html="formatGroupAge"></div>
			</el-col>
		</div>

    </el-row>
</template>

<script>
import EntityService from '@/services/entity.service'

export default {
	name: 'CheckupElement',
	props: ['element','textSign'],
	data() {
    	return {
			name: ''
		};
	},
	computed: {

		// Couleur de l'élément
		backgroundColor() {
			if (this.element.color == null) {
				return null;
			}
			else {
				return this.element.color.toLowerCase() + '-checkupGravity';
			}
		},
		// Pour mettre la coche
		nocross() {
			if (this.element.value == 'true') {
				return '';
			}
			else {
				return 'blank';
			}	 
		},
		// Pour mettre la coche sur un groupe
		nocrossGroup() {
			if (this.element.child1[0].value == 'true') {
				return '';
			}
			else {
				return 'blank';

			}
		},
		// Formatage texte
		formatText: function () {
			var value = this.element.value;
			if (!value) {
				value = '';
			}

			// Concatène les valeurs de chaque fils à la valeur du parent
			if (this.element.child1) {
				this.element.child1.forEach(child => {
					if (child.value) {
						value += ' ' + child.value;
					}
				});
			}
			
			if (typeof value === 'string') {
				value = value.replaceAll('\n', '<br>')
			}

			if (this.element.libelle.indexOf('{}') < 0) {
				return this.element.libelle + " : " + '<b>'+ value + '</b>';
			}
			if (value == '') {
				value = '...';
			}

			return this.element.libelle.replace('{}', '<b>' + value + '</b>');
		},

		// Formatage image
		formatImage: function () {
			
			var value = this.element.value;
			if (value == '') {
				return '';
			}
			return this.textSign + '<img src="' + value + '"  style="width: 100%;"  />';
		},

		// Formatage d'un temps grace au balise {1} et {2}
		formatTime: function () {
			var value1 = null;
			var value2 = null;
			if (this.element.value != null) {
				value1 = this.element.value.substr(0,2);
				value2 = this.element.value.substr(3);
			}
			if (value1 == null) {
				value1 = '...';
			}
			if (value2 == null) {
				value2 = '...';
			}
			return this.element.libelle.replace('{1}', '<b>'+ value1 + '</b>').replace('{2}', '<b>'+ value2 + '</b>');
		},
		// Formatage Groupe idem texte
		formatGroup: function () {
			var value = this.element.child1[1].value;
			if (value == null) {
				value = '';
			}
			if (this.element.libelle.indexOf('{}') < 0) {
				return this.element.libelle + " : " + '<b>'+ value + '</b>';
			}
			if (value == '' || value == null) {
				value = '...';
			}
			return this.element.libelle.replace('{}', '<b>'+ value + '</b>');
		},
		// Formatage Groupe temps idem temps
		formatGroupTemps: function () {
			var value1 = null;
			var value2 = null;

			if (this.element.child1[1].value != null) {
				value1 = this.element.child1[1].value.substr(0,2);
				value2 = this.element.child1[1].value.substr(3);
			}

			if (value1 == null) {
				value1 = ' ... ';
			}
			if (value2 == null) {
				value2 = ' ... ';
			}
			return this.element.libelle.replace('{1}', '<b>'+ value1 + '</b>').replace('{2}', '<b>'+ value2 + '</b>');
		},

		formatGroupAge: function () {
			var value1 = '';
			var value2 = '';


			if (this.element.child1[0].value != null) {
				value1 = this.element.child1[0].value;
			}
			if (this.element.child1[1].value == 'a') {
				value2 = 'Ans';
			}
			if (this.element.child1[1].value == 'm') {
				value2 = 'Mois';
			}
			if (this.element.child1[1].value == 'j') {
				value2 = 'Jours';
			}

			return this.element.libelle + ': ' + '<b>'+ value1 + '</b>' + ' ' + '<b>'+ value2 + '</b>';
		}	 
	},
	mounted: function() {

		// si c'est un etare ref
		if (this.element.type === 'artemisEtareRef') {

			const value = this.element.value;

			// Par défaut on affiche la valeur
			this.name = this.element.libelle + " : " + '<b>'+ value + '</b>';

			// Si c'est un numérique
			// on essaye de trouver une correspondance parmis les entités
			if (value && !isNaN(value)) {
				EntityService.getNameByArtemisId(parseInt(value)).then((name) => {
					this.name = this.element.libelle + " : " + '<b>'+ name + '</b>';
				})	
			}
		}
		
	}
};
</script>

<style scoped>

	.iborder {
		border-width: 1px;
		background-color: white;
		border-radius: 4px;
		border-color: black;
		border-style: outset;
		font-weight: bold;
		font-size: 18px;
	}

	.blank {
		color: white;	
	}

	.chekup-detail {
		border-radius: 4px;
		border: none;
		margin: 5px;
		height: auto !important;
		border-style: dotted;
		border-width: 1px;
		border-color: gray;
		
	}

	/*   Position de Secondaire */
	.checkboxPosition {
		text-align: end;
		padding-right: 3px;
	}


	.chekup-detail-content {
		margin-left: 5px;
		margin-top:3px;
		margin-bottom:3px;
		text-align: left;
	}

	.cross{
		margin-top: 1px;
		font-size: 16px;
		font-weight: bold;
		text-align: right;
		color:rgb(0, 0, 0);
	}

</style>
